import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-152">
      {/* Background Image with Overlays */}
      <div className="absolute inset-0 z-0" data-id="element-153">
        <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=2000&auto=format&fit=crop" alt="Confident elegant woman" className="w-full h-full object-cover object-top opacity-40" data-id="element-154" />
        <div className="absolute inset-0 bg-gradient-to-b from-deep-black/40 via-deep-black/80 to-deep-black" data-id="element-155"></div>
        <div className="absolute inset-0 bg-burgundy/10 mix-blend-overlay" data-id="element-156"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 pt-24 pb-20 text-center" data-id="element-157">
        <FadeIn delay={0.2} data-id="element-158">
          <div className="inline-block mb-6 px-4 py-1.5 rounded-full border border-champagne-gold/30 bg-deep-black/50 backdrop-blur-sm" data-id="element-159">
            <span className="text-champagne-gold text-xs font-semibold tracking-[0.2em] uppercase" data-id="element-160">
              Reprends le contrôle. Deviens inoubliable.
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-161">
          <h1 className="font-playfair text-5xl md:text-7xl lg:text-8xl font-bold mb-8 leading-tight gold-shimmer" data-id="element-162">
            L'ALGORITHME DE L'AMOUR :<br data-id="element-163" />
            <span className="italic font-light" data-id="element-164">L'EFFET OBSESSION</span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-165">
          <h2 className="text-2xl md:text-3xl font-playfair text-cream mb-6" data-id="element-166">
            La méthode que les femmes les plus courtisées utilisent pour ne plus
            jamais subir le dating digital.
          </h2>
        </FadeIn>

        <FadeIn delay={0.8} data-id="element-167">
          <p className="text-lg md:text-xl text-muted-cream max-w-2xl mx-auto font-light tracking-wide mb-12" data-id="element-168">
            Scripts prêts à copier • Test en 3 messages • Résultat en 48h
          </p>
        </FadeIn>

        <FadeIn delay={1.0} data-id="element-169">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => {
          const el = document.getElementById('arsenal-cta');
          if (el) {
            const y = el.getBoundingClientRect().top + window.scrollY - window.innerHeight * 0.55;
            window.scrollTo({
              top: y,
              behavior: 'smooth'
            });
          }
        }} className="group relative z-20 inline-flex items-center justify-center px-8 py-4 sm:px-12 sm:py-5 text-sm sm:text-base font-bold text-deep-black uppercase tracking-widest bg-champagne-gold rounded-full shadow-gold-glow hover:shadow-gold-glow-lg transition-all duration-300 cursor-pointer" data-id="element-170">
            <span className="relative z-10" data-id="element-171">Découvrir le Secret</span>
            <div className="absolute inset-0 rounded-full bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-172"></div>
          </motion.button>
        </FadeIn>

        {/* Ebook Cover */}
        <FadeIn delay={1.2} data-id="element-173">
          <div className="mt-16 flex justify-center" data-id="element-174">
            <motion.div animate={{
            y: [0, -8, 0]
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'easeInOut'
          }} className="relative" data-id="element-175">
              <div className="absolute -inset-6 bg-champagne-gold/10 rounded-3xl blur-2xl" data-id="element-176"></div>
              <img src="https://cdn.magicpatterns.com/uploads/daztqiWmen7ceve4wfF7Ps/COVER.png" alt="L'Algorithme de l'Amour — L'Effet Obsession" className="relative w-64 md:w-80 rounded-2xl shadow-2xl shadow-champagne-gold/20 border border-champagne-gold/20" data-id="element-177" />
            </motion.div>
          </div>
        </FadeIn>
      </div>

      {/* Scroll indicator */}
      <motion.div animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 2,
      ease: 'easeInOut'
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-50" data-id="element-178">
        <span className="text-xs tracking-widest uppercase text-champagne-gold" data-id="element-179">
          Scroll
        </span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-champagne-gold to-transparent" data-id="element-180"></div>
      </motion.div>
    </section>;
}